import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Alert, ListGroup, ListGroupItem } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as StudySites from '../store/StudySites';
import * as utility from '../data/Utility';

class SelectStudySiteInternal extends React.Component {
    constructor(props) {
        super(props);

        const createAccount = utility.propCheck(props.createAccount, false);
        const createPatient = utility.propCheck(props.createPatient, false);
        const editAccount = utility.propCheck(props.createAccount, false);
        const patientCode = utility.propCheck(props.patientCode, "");
        const userName = utility.propCheck(props.userName, "");
        this.state = {
            createAccount: createAccount,
            createPatient: createPatient,
            editAccount: editAccount,
            patientCode: patientCode,
            userName: userName
        };

        this.getListGroup = this.getListGroup.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    getListGroup(studySites) {

        const listItems = studySites.map(studySite => {
            const name = utility.formatStudySiteName(studySite);
            var to = null;

            if (this.state.createAccount) {
                to = {
                    pathname: paths.createAccount,
                    state: {
                        create: true,
                        linkReturn: true,
                        studySite: studySite
                    }
                }
            }
            else if (this.state.createPatient) {
                to = {
                    pathname: paths.createPatient,
                    state: {
                        studySite: studySite
                    }
                }
            }
            else if (this.state.editAccount) {
                to = {
                    pathname: paths.account,
                    state: {
                        linkReturn: true,
                        studySite: studySite,
                        userName: this.state.userName
                    }
                }
            }
            else {
                to = {
                    pathname: paths.patient,
                    state: {
                        create: false,
                        studySite: studySite
                    }
                }
            }

			const isSelectingPatient = (! this.state.createAccount && ! this.state.editAccount);
			const isStudyWithEvents = studySite.study.isServiceEvent;
			const unselectable = isSelectingPatient && isStudyWithEvents;

			if ( unselectable ) {
				return "";
			} else {
				return (
					<ListGroupItem key={studySite.id} disabled={unselectable} tag={Link} to={to} title={name} action>
						{name}
					</ListGroupItem>
				);
			}
        });
        return (
            <ListGroup>
                {listItems}
            </ListGroup>
        );
    }

    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAdministrator(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching)) {
            this.props.studySitesDispatch.getAll();
        }
    }

    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        var error = false;
        var message = "";
        var patientCode = this.state.patientCode;
        var studySiteList = null;
        const studySites = this.props.studySitesState.all;
        var toTitle = "";
        var userName = this.state.userName;

        if (studySites != null &&
            studySites.map != null) {
            studySiteList = this.getListGroup(studySites);
        }
        else {
            error = true;
            message = "Error retrieving study/sites.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        if (patientCode === "") {
            patientCode = "{empty}";
        }
        if (userName === "") {
            userName = "{empty}";
        }

        if (this.state.createAccount ||
            this.state.editAccount) {
            toTitle = ` to account user name '${userName}'`;
        }
        else {
            toTitle = ` to patient code '${patientCode}'`;
        }

		const helpText = "If a study/site does not appear in the list below, Dyna-Vision must be used to create/edit patients for the study.";

        return (
            <div>
                <h1>Link Study/Site<small>{toTitle}</small></h1>
                <h5><small>{helpText}</small></h5>
                <br />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                {studySiteList}
            </div>
        );
    }
}

const SelectStudySiteConnect = connect(
    state => ({
        accountsState: state.accounts,
        studySitesState: state.studySites
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        studySitesDispatch: bindActionCreators(StudySites.actionCreators, dispatch)
    })
)(SelectStudySiteInternal);

export default class SelectStudySite extends React.Component {
    render() {
        var createAccount = false;
        var createPatient = false;
        var editAccount = false;
        var patientCode = "";
        var userName = "";

        const propsState = this.props.location.state;
        if (propsState != null) {
            createAccount = utility.propCheck(propsState.createAccount, createAccount);
            createPatient = utility.propCheck(propsState.createPatient, createPatient);
            editAccount = utility.propCheck(propsState.editAccount, editAccount);
            patientCode = utility.propCheck(propsState.patientCode, patientCode);
            userName = utility.propCheck(propsState.userName, userName);
        }

        return (
            <ErrorBoundary>
                <SelectStudySiteConnect createAccount={createAccount} createPatient={createPatient} editAccount={editAccount} patientCode={patientCode} userName={userName} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectStudySite.js